import Keycloak from 'keycloak-js';

const authStaging = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user'
};

const authDev = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user'
};

const endpointsDev = {
  environment: 'dev',
  base_url: 'https://viana-dev-copy3.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-dev.azurewebsites.net/',
  portal_url: 'https://dev.portal.internal.viana.ai/'
};

const endpointsNode16Dev = {
  environment: 'node16_dev',
  base_url: 'https://viana-services-staging-copy3.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging.azurewebsites.net/',
  admin_url: 'https://admin.node16poc.internal.viana.ai/',
  portal_url: 'https://staging4.portal.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};


const endpointsStaging = {
  environment: 'staging',
  // base_url: 'https://viana-services-staging-copy3.azurewebsites.net/',
  base_url: 'https://viana-services-n16-staging-svc-staging4.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging.azurewebsites.net/',
  portal_url: 'https://staging.portal.internal.viana.ai/'
};

const endpointsStaging2 = {
  environment: 'staging',
  base_url: 'https://viana-services-staging-stage.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging.azurewebsites.net/',
  portal_url: 'https://viana-portal-staging-2.web.app/'
};

const authPreproduction = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'preprod',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/preprod/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: '864a614e-590f-4abf-8cf2-ec3b7ebecaab',
  scope: 'openid user'
};

const endpointsPreproduction = {
  environment: 'preproduction',
  base_url: 'https://ppd.services.api.viana.ai/',
  base_url_insights: 'https://viana-insights-preprod.azurewebsites.net/',
  portal_url: 'https://prep.portal.internal.viana.ai/'
};

const endpointsNespressoPreproduction = {
  environment: 'nespresso_ppd',
  base_url: 'https://viana-services-preprod-2-nespresso.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-preprod-nespresso.azurewebsites.net/',
  portal_url: 'https://nespresso.prep.portal.internal.viana.ai/'
};


const authProduction = {
  auth_url: 'https://id.viana.ai/auth',
  realm: 'production',
  access_token_url: 'https://id.viana.ai/auth/realms/production/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: '63b58278-28c8-43a8-abc6-7698c0146c90',
  scope: 'openid user'
};

const endpointsProduction = {
  environment: 'production',
  base_url: 'https://services.api.viana.ai/',
  base_url_insights: 'https://insights.api.viana.ai/',
  portal_url: 'https://portal.viana.ai/'
};

const authDevGCP = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user'
};

const authDevGCP2 = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user',
};

const endpointsDevGcp = {
  environment: 'dev_gcp',
  base_url: 'https://dev-gcp.services.api.viana.ai/',
  base_url_insights: 'https://dev-gcp.insights.api.viana.ai/',
  portal_url: 'https://dev-gcp.portal.internal.viana.ai/',
  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const endpointsDevGcp2 = {
  environment: 'dev_gcp.id2',
  base_url: 'https://viana-services-d-snapper-525981798165.australia-southeast2.run.app/',
  base_url_insights: 'https://crn-viana-dev-ausse2-aiinsights-525981798165.australia-southeast2.run.app/',
  admin_url: 'https://dev-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const authStgGCP = {
  auth_url: 'https://dev-gcp.id.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user'
};

const endpointsStgGCP = {
  environment: 'staging_gcp',
  base_url: 'https://viana-services-210498958095.australia-southeast2.run.app/',
  base_url_insights: 'https://viana-insights-210498958095.australia-southeast2.run.app/',
  portal_url: 'https://viana-portal-210498958095.australia-southeast2.run.app/'
};

/* export const auth = process.env.REACT_APP_VIANA_ENV === 'production'
  ? authProduction
  : process.env.REACT_APP_VIANA_ENV === 'preproduction'
    ? authPreproduction
    : authStaging; */

const authLocal = {
  auth_url: 'http://localhost:8080/',
  realm: 'staging',
  access_token_url: 'http://localhost:8080/auth/realms/local/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user'
};

const endpointsLocal = {
  environment: 'local',
  base_url: 'http://localhost:3000/',
  base_url_insights: 'http://localhost:4000/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
};


export let auth;
if (process.env.REACT_APP_VIANA_ENV === 'production') {
  auth = authProduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'preproduction') {
  auth = authPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'nespresso_ppd') {
  auth = authPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging') {
  auth = authStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev') {
  auth = authStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'node16_dev') {
  auth = authStaging;
} else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp') {
  auth = authDevGCP;
} else if(process.env.REACT_APP_VIANA_ENV === 'local') {
  auth = authLocal;
} else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2') {
  auth = authDevGCP2;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging_gcp') {
  auth = authStgGCP;
} else {
  auth = authStaging;
}


/* export const endpoints = process.env.REACT_APP_VIANA_ENV === 'production'
  ? endpointsProduction
  : process.env.REACT_APP_VIANA_ENV === 'preproduction'
    ? endpointsPreproduction
    : endpointsStaging; */


export let endpoints;
if (process.env.REACT_APP_VIANA_ENV === 'production') {
  endpoints = endpointsProduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'preproduction') {
  endpoints = endpointsPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'nespresso_ppd') {
  endpoints = endpointsNespressoPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging') {
  endpoints = endpointsStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev') {
  endpoints = endpointsDev;
} else if (process.env.REACT_APP_VIANA_ENV === 'node16_dev') {
  endpoints = endpointsNode16Dev;
} else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp') {
  endpoints = endpointsDevGcp;
}else if(process.env.REACT_APP_VIANA_ENV === 'local') {
  endpoints = endpointsLocal;
} else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2') {
  endpoints = endpointsDevGcp2;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging_gcp') {
  endpoints = endpointsStgGCP;
} else {
  endpoints = endpointsStaging;
}



/* let initOptions = {
  url: auth.auth_url, realm: auth.realm, clientId: auth.client_id, onLoad: 'login-required'
};
export let auth;
switch (process.env.REACT_APP_VIANA_ENV) {
  case 'production':
    auth = authProduction;
    break;
  case 'preproduction':
    auth = authPreproduction;
    break;
  case 'nespresso_ppd':
    auth = authPreproduction;
    break;
  case 'staging':
  case 'dev':
  case 'node16_dev':
    auth = authStaging;
    break;
  case 'dev_gcp':
    auth = authDevGCP;
    break;
  case 'local':
    auth = authLocal;
    break;
  default:
    auth = authStaging;
}

// Same for endpoints
export let endpoints;
switch (process.env.REACT_APP_VIANA_ENV) {
  case 'production':
    endpoints = endpointsProduction;
    break;
  case 'preproduction':
    endpoints = endpointsPreproduction;
    break;
  case 'nespresso_ppd':
    endpoints = endpointsNespressoPreproduction;
    break;
  case 'staging':
    endpoints = endpointsStaging;
    break;
  case 'dev':
    endpoints = endpointsDev;
    break;
  case 'node16_dev':
    endpoints = endpointsNode16Dev;
    break;
  case 'dev_gcp':
    endpoints = endpointsDevGcp;
    break;
  default:
    endpoints = endpointsStaging;
}
*/

const initOptions = {
  url: auth.auth_url,
  realm: auth.realm,
  clientId: auth.client_id,
  onLoad: 'login-required',
  checkLoginIframe: false, // helps prevent issues in some environments
  pkceMethod: 'S256' // Recommended for v26+
};




export const keycloak = new Keycloak(initOptions);
